import { render, staticRenderFns } from "./agregaOportunidaNatural.vue?vue&type=template&id=35b78a2a&scoped=true"
import script from "./agregaOportunidaNatural.vue?vue&type=script&lang=js"
export * from "./agregaOportunidaNatural.vue?vue&type=script&lang=js"
import style0 from "./agregaOportunidaNatural.vue?vue&type=style&index=0&id=35b78a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b78a2a",
  null
  
)

export default component.exports